import userDefault from '../assets/img/Explore-w-Imray-user-image-default@2x.jpg'
import { Dropdown } from 'react-bootstrap'
import { API } from '../api'

export function camelCaseToTitle(s) {
  return s.charAt(0).toUpperCase() + s.substr(1).replace(/([A-Z]+)/g, ' $1')
}

export function linkify(text) {
  // emails first
  return linkPhones(linkUrls(linkEmails(convertNewLines(text))))
}

//const domainRegex = /(?<![@a-z0-9-])(([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,6})(?![a-z0-9-@])/gi; // no lookbehind support in Safari
const domainRegex =
  /(([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,6}(\/[\/a-z0-9-_+.]*)?)(?![a-z0-9-@]|['"]>|<\/a>|\.[a-z0-9])/gi
const email_regex =
  /([a-zA-Z0-9._-]+@(([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,6})(?![a-z0-9-@]|['"]>|\.[a-z0-9]))/gi
const tel_regex = /(?:✆\s*)(\+?[0-9 -]+)/gi

function linkUrls(text) {
  const result = text.replace(
    domainRegex,
    "<a href='http://$1' target='_blank'>$1</a>"
  )
  return result
}

function linkEmails(text) {
  const result = text.replace(email_regex, "<a href='mailto:$1'>$1</a>")
  return result
}

function linkPhones(text) {
  const result = text.replace(tel_regex, "✆<a href='tel:$1'>$1</a>")
  return result
}

function convertNewLines(text) {
  const nl_regex = /\\r\\n/gi
  const result = text.replace(nl_regex, '<br />')
  return result
}

export function buildComments(
  comments,
  cloudinaryFolder,
  onReportClick,
  onEnlargeModalOpen
) {
  let html = []
  comments.forEach(v => {
    html.push(
      buildComment(v, cloudinaryFolder, onReportClick, onEnlargeModalOpen)
    )
  })

  html.push(
    <div id="scroll-filler" key="filler">
      &nbsp;
    </div>
  )

  return html
}

function imageExists(image_url) {
  const http = new XMLHttpRequest()

  http.open('HEAD', image_url, false)
  http.send()

  return http.status != 404
}

function buildComment(
  comment,
  cloudinaryFolder,
  onReportClick,
  onEnlargeModalOpen
) {
  const status = buildCommentStatus(comment)

  let hasImagesClass = ''
  let images = []

  if (!stringIsNullOrEmpty(comment.images)) {
    hasImagesClass = 'has-images'
    let splitImages = comment.images.split(';')
    splitImages = splitImages.filter(function (element) {
      return element !== null && element !== undefined && element !== ''
    })

    const res = splitImages.length == 1 ? 'h_380,w_688' : 'h_240,w_341'
    const socialImagesBaseURL = `https://res.cloudinary.com/${cloudinaryFolder}/image/upload/c_limit,${res}/`

    splitImages.forEach(imageId => {
      images.push(
        <div key={imageId}>
          <img
            className="expandable-image social-post-image"
            alt="Comment image"
            title="Comment image"
            src={socialImagesBaseURL + imageId + '.jpg'}
            onClick={e => {
              e.stopPropagation()
              onEnlargeModalOpen(socialImagesBaseURL + imageId + '.jpg', '')
            }}
          />
        </div>
      )
    })
  }

  let html = (
    <div
      className={`ug-post-list-item ${hasImagesClass}`}
      id={`comment_${comment.id}`}
      key={comment.id}
    >
      <div>
        <div className="ug-post-profile-info-row">
          <div>
            <img
              alt="User avatar"
              src={getUserImageUrl(comment.user, cloudinaryFolder)}
            />
            <div>
              <h5>
                {comment.user?.firstName} {comment.user?.lastName}
              </h5>
              <p>{new Date(comment.created).toLocaleString()}</p>
            </div>
          </div>
          <Dropdown
            drop="up"
            // this is done on purpose in order to override the default bsPrefix="dropdown"
            bsPrefix=" "
          >
            <Dropdown.Toggle
              id="moreDropdown"
              bsPrefix="ug-post-more-button btn-pill no-fill no-label"
              as="a"
            >
              <span className="material-icons">more_horiz</span>
            </Dropdown.Toggle>

            <Dropdown.Menu id="social-post-dropup-menu">
              <Dropdown.Item
                bsPrefix="dropdown-item post-more-item"
                onClick={e => {
                  e.stopPropagation()
                  onReportClick(comment.id)
                }}
              >
                <span className="material-icons">outlined_flag</span>Report
                comment
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <p className="ug-post-body-preview">{comment.comment}</p>
        <div className="ug-post-images">
          <div className="social-post-image-collection">{images}</div>
        </div>
      </div>
      <div
        id="location-comment-status"
        className={`ug-post-interactions ${
          comment.bookTimestamp !== null &&
          comment.bookTimestamp !== undefined &&
          comment.bookTimestamp !== ''
            ? 'has-timestamp'
            : ''
        }`}
      >
        {status}
      </div>
      {comment.bookTimestamp && (
        <div id="location-comment-book-timestamp">{comment.bookTimestamp}</div>
      )}
    </div>
  )

  return html
}

export function buildCommentStatus(comment) {
  let style, icon
  switch (comment.bookNodeCommentStatusId) {
    case '16b234b3-4f24-458b-b4d1-4d3ab6cc3961':
      style = 'ug-post-submitted'
      icon = 'watch_later'
      break
    case '8c182e11-64ed-4a3d-b823-62cf04958459':
      style = 'ug-post-approved'
      icon = 'gpp_good'
      break
    case 'bdbbf313-ffcb-4c4c-a866-4f019a983064':
      style = 'ug-post-contribution'
      icon = '3p'
      break
    default:
      style = ''
      icon = 'help_outline'
      break
  }

  return (
    <a className={`btn-pill small-pill ${style} disabled`}>
      <span className="material-icons">{icon}</span>
      {comment.bookNodeCommentStatus.name}
    </a>
  )
}

export function getUserImageUrl(userData, cloud) {
  const imageBaseUrl = `https://res.cloudinary.com/${cloud}/image/upload/c_limit,h_128,w_128/`
  return userData !== null &&
    userData !== undefined &&
    userData.imageId !== null &&
    userData.imageId !== undefined &&
    userData.imageId !== ''
    ? `${imageBaseUrl}${userData.imageId}?${new Date(
        userData.lastUpdated
      ).getTime()}`
    : userDefault
}

export function stringIsNullOrEmpty(string) {
  return (
    string === null ||
    string === undefined ||
    string === '' ||
    string.length === 0
  )
}

export const fixValues = function (key, value) {
  // fix nulls
  if (value === null || value === 'null') return ''

  return value
}

export const removeDuplicates = list => {
  const seen = new Set()
  return list.filter(item => {
    const duplicate = seen.has(item?.properties?.id)
    seen.add(item?.properties?.id)
    return !duplicate
  })
}

/**
 * Helper to construct multiple API calls that can later be called simultaneously
 *
 * Use ONLY for POST and GET requests
 * @function
 * @param {string} options.method - POST | GET
 * @param {string} options.endpoint - URL to call
 * @param {string} options.dynamicProp
 * Only works for POST requests
 */
export const conjurePromises = async (strings, options) => {
  const axiosPromises = strings.map(id => {
    switch (options?.method) {
      case 'GET':
        return API.get(options?.endpoint, { params: { id } })
      case 'POST':
        return API.post(
          options?.endpoint,
          options.dynamicProp ? { [options.dynamicProp]: id } : { id }
        )
      default:
        return undefined
    }
  })

  return await Promise.all(axiosPromises)
}
